import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import AppRoutes from 'routes/Routers/AppRoutes';
import MaintenancePage from 'pages/Maintenance/MaintenancePage';

// TODO:
// After company firebase account is setup, go to google analytics and connect the firebase
// property to google analytics, replace the initialize code below
// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-000000-01');
// ReactGA.pageview(window.location.pathname + window.location.search);

// CONSTANTS
const isRunningLocally = process.env.NODE_ENV === 'development'; // process.env.NODE_EV will be development if project is being run as local host.
const LATEST_GIT_VERSION = process.env.REACT_APP_GIT_VERSION;
const QUERY_CACHE_TIME = 1000 * 60 * 10; // 1000 ms * 60s * 10 => 10 minutes

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

function App() {
	// Changes default retry for both queries and mutations to 0 so a SINGLE request is made for now.
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				retry: 0,
				cacheTime: QUERY_CACHE_TIME
			},
			mutations: {
				retry: 0,
				cacheTime: QUERY_CACHE_TIME
			}
		}
	});

	return (
		<div className="App">
			<Helmet>
				<title>Sora Finance</title>
			</Helmet>
			<QueryClientProvider client={queryClient}>
				{isMaintenanceMode ? <MaintenancePage /> : <AppRoutes />}
				{isRunningLocally && (
					<>
						<p
							style={{
								position: 'absolute',
								top: 5,
								right: 80,
								padding: 2
							}}
						>
							Build Version:{' '}
							{LATEST_GIT_VERSION &&
								LATEST_GIT_VERSION.slice(0, 8)}
						</p>
						<ReactQueryDevtools initialIsOpen={false} />
					</>
				)}
			</QueryClientProvider>
		</div>
	);
}

export default App;
